module.exports = __webpack_public_path__ + "static/media/protection_paper_getty_mobile.3b5a2d00.jpg";